"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getImageFormExtension = exports.AdvancedFileUpload = void 0;
var _core = require("@material-ui/core");
var _colors = require("@material-ui/core/colors");
var _lodash = _interopRequireDefault(require("lodash"));
var _styles = require("@material-ui/core/styles");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _config = require("react-platform-components/dist/config");
require("./styles/uploader.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var customTheme = (0, _styles.createMuiTheme)({
  palette: {
    primary: _colors.red
  }
});
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    fileUploaderContainer: {
      width: '100%'
    },
    button: function button(props) {
      return {
        marginTop: 16,
        '&:hover': {
          borderColor: 'rgba(0, 0, 0, 0.87)',
          borderWidth: 1,
          borderStyle: 'solid'
        },
        height: props.height || "60px",
        borderRadius: theme.shape.borderRadius
      };
    },
    displayName: {
      fontSize: '0.75rem',
      fontFamily: "Roboto",
      fontWeight: 400,
      lineHeight: 1.66,
      letterSpacing: '0.03333em',
      color: '#5a5959'
    },
    uploadIcon: {
      marginTop: 10
    },
    labelText: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    descriptionContainer: {
      marginTop: 8,
      marginBottom: 15,
      textTransform: 'lowercase',
      color: '#868686'
    },
    uploadInput: {
      cursor: 'pointer',
      display: 'block',
      height: '100%',
      opacity: 0,
      position: 'absolute',
      width: '100%'
    },
    fieldErrorText: {
      marginLeft: 15
    },
    uploadedFilesContainer: {
      marginTop: -44
    },
    deleteFileIcon: {
      color: 'white',
      borderRadius: 90,
      background: 'red',
      fontSize: 19
    },
    fileWrapper: {
      paddingLeft: '0!important'
    }
  };
});
var getImageFormExtension = function getImageFormExtension(extension) {
  switch (extension) {
    case 'doc':
      return 'doc.svg';
    case 'docx':
      return 'doc.svg';
    case 'xls':
      return 'xls.svg';
    case 'xlsx':
      return 'xls.svg';
    case 'pdf':
      return 'pdf.svg';
    case 'csv':
      return 'csv.svg';
    case 'zip':
      return 'zip.svg';
    case 'txt':
      return 'txt.svg';
    case 'json':
      return 'json.svg';
    case 'png':
      return 'png.svg';
    case 'jpg':
      return 'jpg.svg';
    case 'xml':
      return 'xml.svg';
    case 'css':
      return 'css.svg';
    case 'html':
      return 'html.svg';
    case 'js':
      return 'js.svg';
    case 'exe':
      return 'exe.svg';
    case 'dbf':
      return 'dbf.svg';
    case 'psd':
      return 'psd.svg';
    case 'ai':
      return 'ai.svg';
    case 'svg':
      return 'svg.svg';
    case 'rtf':
      return 'rtf.svg';
    case 'iso':
      return 'iso.svg';
    case 'dwg':
      return 'dwg.svg';
    case 'ppt':
      return 'ppt.svg';
    case 'pptx':
      return 'ppt.svg';
    case 'mp4':
      return 'mp4.svg';
    case 'avi':
      return 'avi.svg';
    case 'fla':
      return 'fla.svg';
    case 'mp3':
      return 'mp3.svg';
    case 'gif':
      return 'gif.svg';
    case 'jpeg':
      return 'jpeg.svg';
    default:
      return 'other.svg';
  }
};
exports.getImageFormExtension = getImageFormExtension;
var AdvancedFileUpload = (0, _reactIntl.injectIntl)(function (props) {
  var field = props.field,
    form = props.form,
    maxFiles = props.maxFiles,
    maxSize = props.maxSize,
    minSize = props.minSize,
    maxTotalSize = props.maxTotalSize,
    minTotalSize = props.minTotalSize,
    acceptedFiles = props.acceptedFiles,
    disabled = props.disabled,
    label = props.label,
    description = props.description,
    intl = props.intl,
    height = props.height;
  var classes = useStyles({
    height: height
  });
  var theme = (0, _styles.useTheme)();
  var handleDelete = function handleDelete(item) {
    // delete the file from formik
    form.setFieldValue(field.name, _lodash.default.filter(field.value, function (element) {
      return !_lodash.default.isEqual(element, item);
    }));
    // this used for delete the file that already stored in the server (delete existing file)
    if (item !== null && item !== void 0 && item.id) {
      var fieldToDeleteName = "".concat(field.name, "ToDelete");
      form.setFieldValue(fieldToDeleteName, [].concat(_toConsumableArray(form.values[fieldToDeleteName] || []), [item === null || item === void 0 ? void 0 : item.id]));
    }
  };
  var handleChange = function handleChange(e) {
    var files = _toConsumableArray(e.target.files);
    var hasError = false;
    // Validate file count
    if (maxFiles) {
      var filesCount = (field.value || []).length + files.length;
      if (filesCount > maxFiles) {
        form.setFieldError(field.name, "".concat(intl.formatMessage({
          id: "Le nombre des fichiers doit être inferieur ou éguale à",
          defaultMessage: "Le nombre des fichiers doit être inferieur ou éguale à"
        }), " ").concat(maxFiles));
        form.setFieldTouched(field.name, true, false);
        hasError = true;
      }
    }
    // Validate size of each file
    if (maxSize) {
      if (_lodash.default.some(files, function (file) {
        return file.size >= maxSize;
      })) {
        form.setFieldError(field.name, intl.formatMessage({
          id: 'La taille de fichier doit être inférieure à {value} MB',
          defaultMessage: 'La taille de fichier doit être inférieure à {value} MB'
        }, {
          value: maxSize / 1000000
        }));
        form.setFieldTouched(field.name, true, false);
        hasError = true;
      }
    }
    if (minSize) {
      if (_lodash.default.some(files, function (file) {
        return file.size <= minSize;
      })) {
        form.setFieldError(field.name, intl.formatMessage({
          id: 'La taille de fichier doit être supérieure à {value} MB',
          defaultMessage: 'La taille de fichier doit être supérieure à {value} MB'
        }, {
          value: minSize / 1000000
        }));
        form.setFieldTouched(field.name, true, false);
        hasError = true;
      }
    }
    // Validate the sum of all files
    if (maxTotalSize) {
      var size = 0;
      files.forEach(function (file) {
        return size = size + file.size;
      });
      if (size >= maxTotalSize) {
        form.setFieldError(field.name, intl.formatMessage({
          id: 'La taille des fichiers doit être inférieure à {value} MB',
          defaultMessage: 'La taille des fichiers doit être inférieure à {value} MB'
        }, {
          value: maxTotalSize / 1000000
        }));
        form.setFieldTouched(field.name, true, false);
        hasError = true;
      }
    }
    if (minTotalSize) {
      var _size = 0;
      files.forEach(function (file) {
        return _size = _size + file.size;
      });
      if (_size <= minTotalSize) {
        form.setFieldError(field.name, intl.formatMessage({
          id: 'La taille des fichiers doit être supérieure à {value} MB',
          defaultMessage: 'La taille des fichiers doit être supérieure à {value} MB'
        }, {
          value: minTotalSize / 1000000
        }));
        form.setFieldTouched(field.name, true, false);
        hasError = true;
      }
    }
    if (_lodash.default.some(files, function (file) {
      return acceptedFiles.indexOf(file.type) === -1;
    })) {
      form.setFieldError(field.name, intl.formatMessage({
        id: 'Format de fichier non pris en charge.',
        defaultMessage: 'Format de fichier non pris en charge.'
      }));
      form.setFieldTouched(field.name, true, false);
      hasError = true;
    }
    if (!hasError) {
      form.setFieldValue(field.name, [].concat(_toConsumableArray(field.value || []), _toConsumableArray(files)));
    }
    e.target.value = null;
  };
  var meta = form.getFieldMeta(field.name);
  // Handle error state of the component
  var hasError = Boolean(meta.touched && (meta.error || !_lodash.default.isEmpty(meta.error)));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.fileUploaderContainer
  }, /*#__PURE__*/_react.default.createElement(_styles.MuiThemeProvider, {
    theme: hasError ? customTheme : theme
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "outlined",
    color: hasError ? 'primary' : 'default',
    className: classes.button,
    disabled: Boolean(disabled),
    fullWidth: true
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.Icon, {
    className: classes.uploadIcon
  }, "cloud_upload")), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.labelText
  }, label), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.descriptionContainer
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "caption",
    display: "block",
    gutterBottom: true
  }, description))), /*#__PURE__*/_react.default.createElement("input", {
    type: "file",
    accept: acceptedFiles,
    onChange: handleChange,
    multiple: true,
    className: classes.uploadInput
  })), hasError && /*#__PURE__*/_react.default.createElement(_core.FormHelperText, {
    error: hasError,
    className: classes.fieldErrorText
  }, meta.error), /*#__PURE__*/_react.default.createElement("div", {
    className: "uploaded-files"
  }, /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", {
    className: classes.uploadedFilesContainer
  }, /*#__PURE__*/_react.default.createElement("ul", null, _lodash.default.map(field.value, function (item, index) {
    var fileName = item instanceof File ? item.name : item.name.split('/').pop();
    var fileExtension = fileName.split('.').pop();
    var fileSize = item.size ? item.size < 1024 * 1024 ? "".concat((item.size / 1000).toFixed(1), " KB") : "".concat((item.size / (1024 * 1024)).toFixed(1), " MB") : undefined;
    return /*#__PURE__*/_react.default.createElement("li", {
      className: classes.fileWrapper,
      key: index
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("section", {
      className: "uploaded-area"
    }, /*#__PURE__*/_react.default.createElement("li", {
      className: "row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "content upload"
    }, /*#__PURE__*/_react.default.createElement("img", {
      height: 38,
      src: "".concat(_config.STATIC_PATH, "/assets/images/files-icons/").concat(getImageFormExtension(fileExtension)),
      alt: fileName
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "details"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "name"
    }, fileName), fileSize && /*#__PURE__*/_react.default.createElement("span", {
      className: "size"
    }, fileSize))), /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      onClick: function onClick() {
        return handleDelete(item);
      }
    }, /*#__PURE__*/_react.default.createElement(_core.Icon, {
      className: classes.deleteFileIcon
    }, "close"))))));
  })))))));
});
exports.AdvancedFileUpload = AdvancedFileUpload;